import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Seleniumtemplate extends Component {
  render() {
    const course = [
        {
              title: "Introduction to Selenium",
              content: [
                "Overview of Selenium",
                "History and Evolution",
                "Supported Platforms and Browsers",
                "Selenium IDE, WebDriver, and Grid",
                "Setting up the Selenium Environment"
              ]
            }, {
              title: "Selenium IDE",
              content: [
                "Installing and Launching Selenium IDE",
                "IDE Features and Functions",
                "Recording and Running Test Cases",
                "Editing and Debugging Test Cases",
                "Exporting Test Cases"
              ]
            }, {
              title: "Locator Strategies",
              content: [
                "Introduction to Locators",
                "ID, Name, Class, Tag Name, Link Text, and Partial Link Text Locators",
                "CSS Selectors and XPath Locators",
                "Choosing Effective Locators",
                "Best Practices for Locators"
              ]
            }, {
              title: "Selenium WebDriver",
              content: [
                "WebDriver Interface and Drivers",
                "Setting up WebDriver for Different Browsers",
                "Basic WebDriver Commands",
                "Navigating Web Pages",
                "Managing Browser Windows and Tabs"
              ]
            }, {
              title: "Working with Web Elements",
              content: [
                "Interacting with Web Elements",
                "Input, Button, Checkbox, and Radio Button Operations",
                "Dropdown and Select Operations",
                "Handling Alerts and Pop-ups",
                "Mouse and Keyboard Actions"
              ]
            }, {
              title: "Synchronization and Waits",
              content: [
                "Types of Waits in Selenium",
                "Implicit and Explicit Waits",
                "Fluent Wait",
                "Expected Conditions in Selenium",
                "Handling Synchronization Issues"
              ]
            }, {
              title: "Handling Frames and Windows",
              content: [
                "Switching between Frames",
                "Working with Multiple Windows",
                "Handling Pop-up Windows",
                "Frame and Window Identification Strategies",
                "Best Practices for Frame and Window Handling"
              ]
            }, {
              title: "TestNG Framework",
              content: [
                "Introduction to TestNG",
                "Setting up TestNG in Eclipse",
                "Creating and Running Test Suites",
                "Annotations and Priorities",
                "Parameterized Testing"
              ]
            }, {
              title: "Page Object Model (POM)   Pattern",
              content: [
                "Understanding POM",
                "Benefits and Best Practices of POM",
                "Implementing POM in Selenium",
                "Creating Page Classes",
                "Executing Tests with POM"
              ]
            }, {
              title: "Handling Cookies and Pop-ups",
              content: [
                "Working with Cookies in Selenium",
                "Adding, Deleting, and Modifying Cookies",
                "Handling JavaScript Alerts and Pop-ups",
                "Browser Notifications",
                "Managing Authentication Pop-ups"
              ]
            }, {
              title: "Test Data Management",
              content: [
                "Test Data Sources",
                "Data-Driven Testing",
                "Reading Data from Excel, CSV, and Databases",
                "Parameterization using TestNG",
                "Managing Test Data Files"
              ]
            }, {
              title: "Selenium Grid and Remote Execution",
              content: [
                "Introduction to Selenium Grid",
                "Setting up Grid Hub and Nodes",
                "Creating and Running Tests on Grid",
                "Remote Execution on Different Browsers",
                "Parallel Test Execution"
              ]
            }
    ]

    const faqData = [
      {
        question: 'What is Selenium?',
        answer:
          'Selenium is a popular open-source automation testing tool used for automating web applications across different browsers and platforms',
      },
      {
        question: 'Why is Selenium important in software testing?',
        answer:
          'Selenium is crucial for software testing as it allows for the automation of repetitive tasks, ensures faster testing cycles, improves test coverage, and enhances the accuracy of test results',
      },
      {
        question: 'What types of testing can be performed using Selenium?',
        answer:
          `Selenium is primarily used for functional testing of web applications. It can perform tasks like form filling, button clicking, navigation, and data extraction. It's also commonly used for regression testing.`,
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Selenium skills can pursue roles such as Automation Test Engineer, Quality Assurance (QA) Engineer, Test Automation Architect, Selenium Test Lead, Software Development Engineer in Test (SDET), Continuous Integration/Continuous Deployment (CI/CD) Teste.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Selenium automation testing at the Best Training Centre. Our comprehensive Selenium training program welcomes learners from diverse backgrounds, regardless of prior experience with testing tools or programming languages. Whether you're a software tester, developer, or IT professional aiming to master Selenium for automated testing, our courses cater to individuals at every skill level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Selenium concepts, including test automation frameworks, WebDriver, test scripts development, and integration with continuous integration tools. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in the dynamic field of Selenium automation testing. Join us and unlock your expertise in Selenium with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:`  Selenium  Training in ${this.props.location} is a stepping stone to a successful career in automation testing. It equips you with the knowledge and skills to   efficient and maintainable Selenium frameworks. You can ensure you receive top-notch education in Selenium  .`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:" Certification in Selenium   is more than just a piece of paper. It signifies your expertise and knowledge in Selenium automation testing. It acts as a validation of your skills and can open doors to better job opportunities and career growth."
      },
  ]
 
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the realm of web development, the pursuit of seamless, error-free applications is paramount. This is where Selenium steps in, a powerhouse open-source software testing framework revered for its prowess in automating web browsers. Selenium equips testers and developers with a robust suite of tools and libraries, enabling the automation of web application testing across diverse browsers and platforms. Its versatility, scalability, and compatibility with browsers like Chrome, Firefox, and Safari make Selenium the go-to choice for web-based application testing."/> */}
         
          <NewMainsec rating='4.2' students={"205"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the realm of web development, the pursuit of seamless, error-free applications is paramount. This is where Selenium steps in, a powerhouse open-source software testing framework revered for its prowess in automating web browsers. Selenium equips testers and developers with a robust suite of tools and libraries, enabling the automation of web application testing across diverse browsers and platforms. Its versatility, scalability, and compatibility with browsers like Chrome, Firefox, and Safari make Selenium the go-to choice for web-based application testing."/>

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Are you searching for top-notch Selenium training in ${this.props.location} to boost your career in software testing and automation? Look no further than learnsoft.org! Our Selenium courses in ${this.props.location} are expertly  ed to equip you with the skills and knowledge needed to excel in this competitive field. We offer comprehensive training led by seasoned trainers who use a hands-on approach, incorporating real-world scenarios and practical exercises to ensure your success. Whether you're a Selenium novice or a seasoned pro, our Selenium training in ${this.props.location} is your ticket to advancing your career. Contact us today to explore our courses and kickstart your Selenium journey with confidence.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={`Our comprehensive Selenium course in ${this.props.location} covers a wide range of essential topics, including such us Selenium fundamentals, Selenium WebDriver, Test framework development,Integration with industry tools,Real-world test automation scenarios, Our experienced trainers will guide you through hands-on exercises and real-world examples, ensuring you grasp the concepts and techniques crucial for Selenium mastery. By the end of the course, you'll have the confidence to apply Selenium practices effectively in your projects.`}/>
  </section>
          <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Automation Testing" coupath7="automation-testing" cou6='Mean Stack Developer' coupath6='mean-stack-developer' cou4='Python Full Stack Developer' coupath4='python-full-stack-developer' cou='Web Design' coupath='web-design' cou3='Ui-Ux Design ' coupath3='ui-ux-design'
           cou9='Java Full Stack Developer ' coupath9='java-full-stack-developer' cou1='Software Testing' coupath1='software-testing'
          cou5='Mern stack Developer' coupath5='mern-stack-developer' cou2='Web Development' coupath2='web-development'  cou8='Digital Marketing' coupath8='digital-marketing' />

      </>
    );
  }
}
